
import { defineComponent } from "@vue/composition-api";
import { CreateElement, RenderContext } from "vue";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "BaseThumbnailButton",
  functional: true,
  props: {
    title: { type: String },
    iconSize: { type: Number, default: 32 },
    mobileHideText: { type: Boolean, default: false },
  },
  render(h: CreateElement, ctx: RenderContext) {
    return h(
      "button",
      {
        class: ["base-thumbnail-button", "body-2"],
        on: {
          click: ctx.listeners.click,
        },
      },
      [
        h(BaseIcon, { props: { fontSize: ctx.props.iconSize } }, [
          ctx.scopedSlots.default ? ctx.scopedSlots.default({}) : "sci-round-plus",
        ]),
        ctx.props.title
          ? h(
              "span",
              { staticClass: "base-thumbnail-button__title link", class: { __hide: ctx.props.mobileHideText } },
              [ctx.props.title]
            )
          : null,
      ]
    );
  },
});
